import React from 'react';
import { t } from 'i18next';
import CustomMiniCard from '../../../../components/CustomMiniCard';
import NotInformation from '../../../../components/NotInformation';
import { statusColor } from '../../../../enums/statusColorEnum';
import { getDateFormat } from '../../../../Apis/functions';
import { status } from '../../../../enums/statusEnum';
import RowCardText from '../../../../components/RowCardText';
import CustomChip from '../../../../components/CustomChip';

const ActiveContracts = ({ list, userDataTransformContractor }) => {

    return (<>
        {list?.length > 0 ?
            <>
                {list?.map((contract) => {
                    return (
                        <CustomMiniCard>
                            <div className='px-0 d-flex justify-content-between'>
                                <div className='ibl-item-description-green'>{`${t('Folio')} # ${contract?.folio || '-'}`}</div>

                                <CustomChip
                                    background={statusColor[contract?.statusId]}
                                    legend={t(status[contract?.statusId]).toUpperCase() || '-'}
                                />

                            </div>

                            <div className='ibl-item-description-green'>{t('contractor')}</div>
                            <RowCardText title={t('name')} value={userDataTransformContractor([contract])[0].label} />
                            <RowCardText title={t('company')} value={contract?.contractorCompanyAcronym + ' | ' + contract?.contractorCompanyName} />

                            <div className='ibl-item-description-green'>{t('information')}</div>
                            <RowCardText title={t('start_contract')} value={getDateFormat(contract.startDate, false)} />
                            <RowCardText title={t('end_contract')} value={getDateFormat(contract.endDate, false)} />
                            <RowCardText title={t('num_employees')} value={contract?.noEmployees || '-'} />
                            <RowCardText title={t('num_vehicles')} value={contract?.noVehicles || '-'} />

                        </CustomMiniCard>
                    );
                })}
            </>
            :
            <NotInformation text={t('no_information')} card={true} />
        }
    </>);
}

export default ActiveContracts;
